//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'button',
  data() {
    return {
      value: '',
      value_display: '',
      'multiValue': '',
      'multiValue_display': '',
      options: [
        { id: 0, name: '女' },
        { id: 1, name: '男' },
        { id: 2, name: '未知' }
      ]
    };
  }
};



// WEBPACK FOOTER //
// ./example/pages/button-list.vue